import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';
import {UIChart} from 'primeng/primeng';
import * as _ from "lodash";

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as enums from '../../enums/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {MessageHandlerComponent} from '../../components/Controls/MessageHandler.component';
import {BlockComponent} from '../../components/Controls/Block.component';
import {FileFieldEditComponent} from '../../components/Exports/FileFieldEdit.component';


@Component({
  selector: 'my-request-export-property-value-grid',
  templateUrl: './RequestExportPropertyValueGrid.component.html'
})
export class RequestExportPropertyValueGridComponent implements OnInit {

    userInfo: ent.UserInfo;
    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(FileFieldEditComponent) recordEditComponent: FileFieldEditComponent;
    @ViewChild(BlockComponent) blockComponent: BlockComponent;
    records: ent.ExportField[];
    frozenRecords: ent.ExportField[];
    cols: any[];
    customCols: any[];
    requestIDsCSV: string;
    requestIDs: number[] = [];

    constructor(private configService: serv.ConfigService, private authenticationService: serv.AuthenticationService, 
        private router: Router, private exportService: serv.ExportService) 
    { 
      

    }

    ngOnInit(): void {

        if (!this.authenticationService.checkLoginStatus())
        {
            this.router.navigate(['login']);
        }
        this.userInfo = this.authenticationService.getUserInfo();
        this.onSearchClick(null);
    }

    public onSearchClick(event: any){
        
        this.requestIDs = [];
        var requestIDs = _.split(this.requestIDsCSV, ',');

        if (requestIDs.length == 0){
            return;
        }

        this.blockComponent.blocked = true;

        for (var id of requestIDs)
        {
            this.requestIDs.push(parseInt(id));
        }

        this.exportService.getRequestExportPropertyValues(this.requestIDs).subscribe(x=> {
            this.records = x;

            this.customCols = [];

            this.frozenRecords = x.filter(x=>x.ID == 0);
            x = _.remove(x, x=>x.ID ==0);
        
            for (var requestID of this.requestIDs){
                this.customCols.push({field: `Request${requestID}`, header: `Request ${requestID}`});
            }

            this.blockComponent.blocked = false;
        }, err => {
            this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
            this.blockComponent.blocked = false;
        });
    }

    
    
}